export default __webpack_public_path__ + "locales/hy-AM/Files.json?hash=757a514b2eff5a64666791f27c69b589";